// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const GcpIcon = createSvgIcon(
  <svg fill="currentColor" viewBox="0 0 2385.7 1919.9">
    <path
      fill="#EA4335"
      d="M1513.8 528.7h72.8L1794 321.3l10.2-88c-385.9-340.6-975-303.9-1315.6 82A930.6 930.6 0 0 0 287.8 688c23.1-9.5 48.7-11 72.8-4.4l414.7-68.4s21.1-34.9 32-32.7c184.5-202.6 495-226.2 708-53.8z"
    />
    <path
      fill="#4285F4"
      d="M2089.4 688a934 934 0 0 0-281.6-454l-291 291a517.3 517.3 0 0 1 189.9 410.4v51.7c143.1 0 259 116 259 259 0 143.1-116 259-259 259h-518.1l-51.7 52.4v310.7l51.7 51.7h518.1c297 2.3 560.5-190.2 648.7-473.8 88-283.7-20-591.7-266-758.1"
    />
    <path
      fill="#34A853"
      d="M669.8 1917h518.1v-414.7H669.8c-36.9 0-73.4-7.9-107-23.3l-72.8 22.5-208.8 207.4-18.2 72.8A670.6 670.6 0 0 0 669.8 1917"
    />
    <path
      fill="#FBBC05"
      d="M669.8 571.6c-287.8 1.7-542.7 186-634.5 458.7S35 1604 263.1 1779.4l300.5-300.5c-130.4-58.9-188.3-212.3-129.4-342.7s212.3-188.3 342.7-129.4c57.4 26 103.4 72 129.4 129.4l300.5-300.5a673.5 673.5 0 0 0-537-264.1"
    />
  </svg>,
  "Gcp",
);
export default GcpIcon;
